import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ProjectDeleteInterface } from "../../../middleware/interfaces/project/project-delete-interface";

export const ProjectDelete = {
  Delete: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const ProjectDeleteData: ProjectDeleteInterface = state.data;
      const url = "./php/common/deleter-proxy.php";
      await axios
        .post(url, ProjectDeleteData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
